import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { Provider } from 'react-redux';

import { PagesRouter } from '../PagesRouter';
import { IReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { ScrollingContextProvider } from '../Scrolling';
import { ApplicationContext } from '../../utils/applicationContext';
import { selectIsWebview } from '../../selectors/page';

export interface IApplicationProps {
  reduxStore: IReduxStore;
  context: IApplicationContext;
}

export const Application: React.FC<IApplicationProps> = props => {
  const { context, reduxStore } = props;

  const state = reduxStore.getState();

  const isWebview = selectIsWebview(state);

  React.useEffect(() => {
    /* istanbul ignore next */
    /* Костыль для ручного скрытия хэдэра на мобилке, что бы сохранялась авторизация */
    if (typeof window !== 'undefined' && isWebview) {
      const header = document.querySelector('[data-name=HeaderLayout]') as HTMLBodyElement;

      if (header) {
        header.style.display = 'none';
      }
    }
  }, []);

  return (
    <ApplicationContext.Provider value={context}>
      <ErrorLogComponent logger={context.logger}>
        <Provider store={reduxStore}>
          <ScrollingContextProvider>
            <PagesRouter />
          </ScrollingContextProvider>
        </Provider>
      </ErrorLogComponent>
    </ApplicationContext.Provider>
  );
};
